function toggleHeaderClass() {
    const header = document.querySelector('header'),
        section = document.querySelector('#menu-menu-1');
    if(section !== null) {
        const sectionTop = section.getBoundingClientRect().top,
            screenTop = window.pageYOffset || document.documentElement.scrollTop;

        if(sectionTop <= screenTop) {
            header.classList.add('active');
        } else {
            header.classList.remove('active');
        }
    }
}

window.addEventListener('scroll', toggleHeaderClass);

function toggleHeaderClass2() {
    const header = document.querySelector('header'),
        section = document.querySelector('#menu-home');
    if(section !== null) {
        const sectionTop = section.getBoundingClientRect().top,
            screenTop = window.pageYOffset || document.documentElement.scrollTop;

        if(sectionTop <= screenTop) {
            header.classList.add('active');
        } else {
            header.classList.remove('active');
        }
    }
}

window.addEventListener('scroll', toggleHeaderClass2);

function toggleHeaderClass3() {
    const header = document.querySelector('header'),
        section = document.querySelector('#reservation');
    if(section !== null) {
        const sectionTop = section.getBoundingClientRect().top,
            threshold = 280;

        if(sectionTop <= threshold) {
            header.classList.add('act');
        } else {
            header.classList.remove('act');
        }
    }
}

window.addEventListener('scroll', toggleHeaderClass3);

function smoothScrollInsideContainer(e) {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute("href"),
        targetElement = document.querySelector(targetId),
        container = document.querySelector('.wrapper-container');
    const headerHeight = 250;
    const scrollOptions = {
        top: targetElement.offsetTop - headerHeight,
        left: 0,
        behavior: 'smooth'
    };

    container.scrollTo(scrollOptions);
}

document.querySelectorAll('.wrapper-container a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", smoothScrollInsideContainer);
});


document.addEventListener('DOMContentLoaded', function() {
    const burgerButton = document.querySelector('.burger-menu-button'),
        closeButton = document.querySelector('.close-menu-button'),
        menu = document.querySelector('.page-header__menu'),
        menuItems = document.querySelectorAll('.page-header__menu a');

    if(burgerButton && menu) {
        burgerButton.addEventListener('click', function() {
            const expanded = burgerButton.getAttribute('aria-expanded') === 'true';
            menu.classList.toggle('active');
            burgerButton.setAttribute('aria-expanded', !expanded);
        });
    }

    if(closeButton) {
        closeButton.addEventListener('click', function() {
            menu.classList.remove('active');
            burgerButton.setAttribute('aria-expanded', false);
        });
    }

    // Додавання обробника подій для кожного пункту меню
    menuItems.forEach(item => {
        item.addEventListener('click', function() {
            menu.classList.remove('active');
            // Перевірка на наявність burgerButton перед зміною aria-expanded
            if(burgerButton) {
                burgerButton.setAttribute('aria-expanded', false);
            }
        });
    });
});

